import { useFlightContext } from 'legacyfrontend/contexts/FlightDetailsContext';
import { useMemo } from 'react';

const useFlightCodes = (pricingData) => {
  const { flightInfo } = useFlightContext();

  return useMemo(() => {
    if (flightInfo?.origin?.id && flightInfo?.destination?.id) {
      return {
        originCityName: flightInfo.origin.cityName,
        originCode: flightInfo.origin.airportCode,
        destinationCityName: flightInfo.destination.cityName,
        destinationCode: flightInfo.destination.airportCode,
      };
    }

    try {
      const firstJourney =
        pricingData?.solutions?.[0]?.transport?.origin_destinations?.[0]?.journeys?.[0];
      if (!firstJourney?.segments) {
        return {
          originCityName: '',
          originCode: '',
          destinationCityName: '',
          destinationCode: '',
        };
      }

      const firstSegment = firstJourney.segments[0];
      const lastSegment = firstJourney.segments[firstJourney.segments.length - 1];

      return {
        originCityName: firstSegment.origin_city_name,
        originCode: firstSegment.origin_iata,
        destinationCityName: lastSegment.destination_city_name,
        destinationCode: lastSegment.destination_iata,
      };
    } catch (error) {
      console.error('Error extracting flight codes:', error);
      return {
        originCityName: '',
        originCode: '',
        destinationCityName: '',
        destinationCode: '',
      };
    }
  }, [flightInfo, pricingData]);
};

export default useFlightCodes;
